import { handleErrors } from "../../helpers/error";
import http from "../../services/http";
import storage from "../../services/storage";
import { getTicketList, setActivePotData, setTotalPotSize } from "../ui/ticketingPotSlice";

export const getActivePot = ({ onSuccess, onError, onEnd } = {}) => {
  return async (dispatch, getState) => {
    try {
      const res = await http.get({
        url: "v1/pot/active",
        headers: { "x-auth-token": storage.get("xAuthToken") },
      });

        onSuccess?.(res);
      //   dispatch(setReferralCompaignsHistoryDetail(res?.data));

      if (res?.data?.success === true) {
        // console.log("res.data in getActivePot", res.data);
        dispatch(setTotalPotSize(res.data?.pot));
        dispatch(setActivePotData(res.data?.pot));
      }
    } catch (err) {
      if (onError) onError(err);
      handleErrors(err);
    } finally {
      if (onEnd) onEnd();
    }
  };
};

export const GetTicketsApi = ({ onSuccess, onError, onEnd }) => {
  return async (dispatch) => {
    try {
      const res = await http.get({
        url: "v1/admin/product/ticket",
        headers: {
          "x-auth-token": storage.get("xAuthToken"),
        },
      });
      onSuccess(res);
      dispatch(getTicketList(res.data.data));
    } catch (error) {
      if (onError) onError(error);
      handleErrors(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};